<div class="flex w-full h-[64px] lg:h-[80px] bg-black justify-center items-center">
  <div class="flex w-full max-w-[1280px] justify-between items-center lg:px-[40px] pl-[20px] pr-[16px]">
    <div class="flex gap-[40px]">
      <img alt="toonsqaure" class="w-[260px] hidden lg:block" src="/images/common/toonsquare-logo.svg" />
      <img alt="toonsqaure-col" class="w-full max-w-[127px] lg:hidden" src="/images/common/toonsquare-logo-col.svg" />
      <div class="w-fit h-fit hidden lg:block">
        <p-tabs [value]="appService.currentMenu">
          <p-tablist class="menu-tablist">
            @for (menu of appService.menuItem; track menu.id) {
              <p-tab [value]="menu.id" (click)="appService.goToSection(menu.id)"> {{ menu.label }}</p-tab>
            }
          </p-tablist>
        </p-tabs>
      </div>
    </div>
    <div #LanguageOrderWrapper class="w-fit h-fit hidden lg:block" id="language-orders">
      <p-button
        (click)="isOpenLanguageOrder = !isOpenLanguageOrder"
        [styleClass]="'only-icon-black' + (isOpenLanguageOrder ? ' selected' : '')"
        [style]="{ width: '60px', height: '44px', padding: '10px 8px' }"
      >
        <div class="flex gap-[4px] justify-center items-center">
          <img alt="globe" class="w-[24px] h-[24px] text-white" src="/images/common/globe-outline.svg" />
          <img
            [class]="isOpenLanguageOrder ? 'rotate-[180deg]' : ''"
            alt="arrow"
            class="w-[16px] h-[16px] duration-300 ease"
            src="/images/common/arrow-down.svg"
          />
        </div>
      </p-button>
      <p-blockUI [blocked]="isOpenLanguageOrder" class="!bg-transparent" />
    </div>

    <div class="w-fit h-fit lg:hidden">
      <p-button (click)="appService.menuDrawer = true" [styleClass]="'only-icon-black'" [style]="{ width: '48px', height: '48px', padding: '12px' }">
        <img alt="menu" class="w-[24px]" src="/images/common/hamburger-menu.svg" />
      </p-button>
    </div>
  </div>
</div>
<p-overlay
  (onAnimationStart)="setOverlayPositionEnd(LanguageOrderWrapper)"
  [(visible)]="isOpenLanguageOrder"
  [appendTo]="'body'"
  [styleClass]="'language-order-overlay'"
  [style]="{
    width: '120px',
    borderRadius: '10px'
  }"
  [target]="'#language-orders'"
>
  <div
    class="border border-[var(--p-primary-600)] bg-[var(--p-primary-900)] flex flex-col rounded-[10px] p-[8px] gap-[4px] shadow-[0_1px_6px_1px_rgba(0,0,0,0.12)]"
  >
    @for (language of appService.languageArr; track language.id) {
      <div
        class="w-full flex justify-center items-center p-[8px] rounded-[8px] text-[14px] text-[var(--p-surface-50)] language-select cursor-pointer"
        [class]="language.id === appService.usedLanguage() ? 'selected' : ''"
        (click)="changeLanguage(language.id)"
      >
        {{ language.label }}
      </div>
    }
  </div>
</p-overlay>
<p-blockUI [blocked]="isOpenLanguageOrder" class="!bg-transparent" />
<p-drawer #drawerRef [(visible)]="appService.menuDrawer" position="right" styleClass="hamburger-drawer">
  <ng-template #headless>
    <app-mobile-menu-drawer class="h-full w-full md:max-w-[360px]"></app-mobile-menu-drawer>
  </ng-template>
</p-drawer>
<ngx-simplebar class="full"></ngx-simplebar>
